module.exports = __webpack_public_path__ + "img/avatar1.99c8d789.png";